/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Ideal_Midge_VentInputs */

const fr_mild_ideal_midge_vent = /** @type {(inputs: Mild_Ideal_Midge_VentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression`)
};

/**

* @param {Mild_Ideal_Midge_VentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mild_ideal_midge_vent = /** @type {((inputs?: Mild_Ideal_Midge_VentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Ideal_Midge_VentInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mild_ideal_midge_vent(inputs)
});